export default __webpack_public_path__ + "static/media/ic_ellipse.a4940d77.svg";